import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Ruler"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.75 7.5H2.25C1.83579 7.5 1.5 7.83579 1.5 8.25V15.75C1.5 16.1642 1.83579 16.5 2.25 16.5H21.75C22.1642 16.5 22.5 16.1642 22.5 15.75V8.25C22.5 7.83579 22.1642 7.5 21.75 7.5ZM21 15H3V9H6V12H7.5V9H11.25V12H12.75V9H16.5V12H18V9H21V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Ruler.vue"]]);
